import React from "react";
import "./SideNavBar.css";
import { useAuth } from "../../context/auth";

const logoImage = "/images/logoOnBlack.png";
const appleIcon = "/images/apple-icon.png";
const googlePlayIcon = "/images/google-play-icon.png";

const SideNavBar = ({
  isOpen,
  onClose,
  activeNav,
  onNavClick,
  onLoginClick,
  onCreateAccountClick,
}) => {
  const { isAuthenticated, user } = useAuth();

  const handleNavigation = (path, navName) => {
    onNavClick(path);
    onClose();
  };

  const handleLogin = () => {
    onLoginClick();
    onClose();
  };

  const handleCreateAccount = () => {
    onCreateAccountClick();
    onClose();
  };

  const getDashboardPath = () => {
    if (!user?.activeRole) return "/";
    return `/home/${user.activeRole}`;
  };

  const handleDashboardNavigation = () => {
    handleNavigation(getDashboardPath(), "dashboard");
  };

  return (
    <>
      <div
        className={`sidenavbar-overlay ${
          isOpen ? "sidenavbar-overlay-open" : ""
        }`}
        onClick={onClose}
      ></div>

      <div className={`sidenavbar ${isOpen ? "sidenavbar-open" : ""}`}>
        <div className="sidenavbar-header">
          <div className="sidenavbar-logo">
            <img
              src={logoImage}
              alt="NimbleBash Logo"
              className="sidenavbar-logo-image"
              onClick={() => handleNavigation("/", "home")}
            />
          </div>
          <button className="sidenavbar-close" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <nav className="sidenavbar-nav">
          <a
            href="/"
            className={`sidenavbar-nav-link ${
              activeNav === "home" ? "sidenavbar-nav-link-active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              handleNavigation("/", "home");
            }}
          >
            Home
          </a>
          <a
            href="/explore"
            className={`sidenavbar-nav-link ${
              activeNav === "explore" ? "sidenavbar-nav-link-active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              handleNavigation("/explore", "explore");
            }}
          >
            Explore
          </a>

          <a
            href="/about-us"
            className={`sidenavbar-nav-link ${
              activeNav === "about" ? "sidenavbar-nav-link-active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              handleNavigation("/about-us", "about");
            }}
          >
            About Us
          </a>
          <a
            href="/get-in-touch"
            className={`sidenavbar-nav-link ${
              activeNav === "help" ? "sidenavbar-nav-link-active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              handleNavigation("/get-in-touch", "help");
            }}
          >
            Get Help
          </a>
        </nav>

        <div className="sidenavbar-downloads">
          <a
            href="https://apps.apple.com/ng/app/nimblebash/id6752389351"
            className="sidenavbar-download-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="landing-page-download-icon">
              <svg viewBox="0 0 24 24" width="32" height="32">
                <path
                  fill="currentColor"
                  d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z"
                />
              </svg>
            </span>
            <span>Download (Apple Store)</span>
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.nimblebash.nimblebyte"
            className="sidenavbar-download-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="landing-page-download-icon">
              <svg
                viewBox="0 0 24 24"
                width="34"
                height="28"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="#34A853"
                  d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5Z"
                />
                <path
                  fill="#4285F4"
                  d="M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"
                />
                <path
                  fill="#FBBC05"
                  d="M6.05,21.34L14.54,12.85L16.81,15.12L6.05,21.34Z"
                />
                <path
                  fill="#EA4335"
                  d="M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.92 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81Z"
                />
              </svg>
            </span>
            <span>Download (Google Play)</span>
          </a>
        </div>

        <div className="sidenavbar-actions">
          {!isAuthenticated ? (
            <>
              <button className="sidenavbar-login-btn" onClick={handleLogin}>
                Login
              </button>
              <button
                className="sidenavbar-create-account-btn"
                onClick={handleCreateAccount}
              >
                Create Account
              </button>
            </>
          ) : (
            <button
              className="sidenavbar-dashboard-btn"
              onClick={handleDashboardNavigation}
            >
              Go to Dashboard
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default SideNavBar;
